export const viewGroups = [
  { type: 'ACTIVE', label: 'Active' },
  { type: 'COMPLETED', label: 'Completed' },
];
